import {Component, ReactNode} from 'react'
import {ErrorBox} from '@components/commons/error-box/ErrorBox.tsx'
import {StyleSheetManager, ThemeProvider} from 'styled-components'
import {getAppTheme, GlobalStyles} from '@/theme'
import Button from '@components/ui/Button'
import i18next from 'i18next'
import {AlertCircleIcon} from '@components/ui/Icon'

interface ErrorBoundaryProps {
    children: ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = {hasError: false}
    }

    static getDerivedStateFromError() {
        return {hasError: true}
    }

    render() {
        if (this.state.hasError) {
            return (
                <ThemeProvider theme={getAppTheme({name: 'light'})}>
                    <StyleSheetManager>
                        <>
                            <GlobalStyles />
                            <ErrorBox
                                cta={
                                    <Button onClick={() => window.location.reload()}>
                                        {i18next.t('commons:reload_the_page')}
                                    </Button>
                                }
                                icon={<AlertCircleIcon />}
                                title={i18next.t('errors:default')}
                            />
                        </>
                    </StyleSheetManager>
                </ThemeProvider>
            )
        }

        return this.props.children
    }
}
